export default {
  en: {
    id: 'ID',
    loading: 'Loading',
    save: 'Save changes',
    delete: 'Delete',
    publish: 'Publish',
    public: 'Public',
    yes: 'Yes',
    no: 'No',
    view: 'View',
    'view-live': 'View live',
    ok: 'Ok',
    cancel: 'Cancel',
    edit: 'Edit {entity}',
    remove: 'Delete {entity}',
    confirm: 'Confirm',
    reports: 'See reports',
    suspend: 'Suspend',
    reload: 'Update',
    reset: 'Reset',
    filter: 'Filter | Filters',
    name: 'Name',
    empty: 'No data found. { extra }',
    create: 'Create {entity}',
    firstname: 'First Name',
    lastname: 'Last Name',
    email: 'Email',
    message: 'Message',
    privilege: 'Privilege',
    password: 'Password',
    default: 'Default',
    custom: 'Custom',
    start: 'Start',
    end: 'End',
    today: 'Today',
    second: 'Second | Seconds',
    minute: 'Minute | Minutes',
    hour: 'Hour | Hours',
    secondShort: 's',
    minuteShort: 'min',
    hourShort: 'h',
    month: 'Month | Months',
    week: 'Week | Weeks',
    dayOfWeek: 'Day of week | Days of the week',
    day: 'Day | Days',
    year: 'Year | Years',
    date: 'Date',
    install: 'Install',
    owner: 'Owner',
    copy: 'Copy',
    ip: 'IP Address',
    users: 'Users',
    secret: 'Secret',
    log: 'Log',
    description: 'Description',
    label: 'Label',
    duration: 'Duration',
    daysAndHours: 'Days of week',
    blockedDate: 'Blocked date | Blocked dates',
    callDetails: 'Calls details',
    visible: 'Visible',
    hidden: 'Hidden',
    url: 'URL',
    event: 'Event',
    visibility: 'Visibility',
    type: 'Type',
    internalId: 'Internal ID',
    integrationId: 'Integration ID',
    fields: 'Fields',
    activate: 'Activate',
    active: 'Active',
    inactive: 'Inactive',
    settings: 'Settings',
    enable: 'Enable',
    disable: 'Disable',
    add: 'Add',
    activated: 'Activated',
    deactivated: 'Deactivated',
    new: 'New',
    website: 'Website',
    optional: 'Optional',
    options: 'Options',
    attributes: 'Attributes',
    feedback: 'Feedback',
    return: 'Return',
    field: 'Field | Fields',
    color: 'Color',
    required: 'Required',
    readonly: 'Readonly',
    disabled: 'Disabled',
    logo: 'Logo',
    reminder: 'Reminder | Reminders',
    title: 'Title',
    days: 'Days',
    template: 'Template',
    subject: 'Subject',
    status: 'Status',
    startAt: 'Start at',
    endAt: 'End at',
    reassign: 'Reassign',
    storage: 'Storage',
    step: 'Step',
    local: 'Local',
    cloud: 'Cloud',
    video: 'Video',
    show: 'Show',
    hide: 'Hide',
    method: 'Method',
    example: 'Example',
    docs: 'Documentation',
    source: 'Source',
    error: 'Error',
    all: 'All',
    notFound: 'Deleted / Not found',
    createdAt: 'Created at',
    udpatedAt: 'Updated At',
    createdBy: 'Created by',
    updatedBy: 'Updated by',
    answered: 'Answered | Answered',
    search: 'Search',
    abandoned: 'Abandoned | Abandoned',
    transferred: 'Transferred | Transferred',
    dismissed: 'Declined | Declined',
    notification: 'Notification',
    average: 'Average | Averages',
    answer: 'Answer | Answers',
    response: 'Response | Responses',
    location: 'Location | Locations',
    total: 'Total',
    os: 'OS | OS',
    browser: 'Browser | Browsers',
    city: 'City | Cities',
    region: 'State | States',
    device: 'Device | Devices',
    country: 'Country | Countries',
    export: 'Export | Exports',
    unknown: 'Unknown',
    ascending: 'Ascending',
    descending: 'Descending',
    order: 'Order',
    close: 'Close',
    appointmentDetails: 'Appointment details',
    agent: 'Agent',
    user: 'Customer',
    download: 'Download',
    preview: 'Preview',
    unroll: 'Unroll',
    enroll: 'Enroll',
    next: 'Next',
    referrer: 'Link | Links',
    enabled: 'Enabled',
    hours: 'Hours',
    durationUnits: { w: 'w', d: 'd', h: 'h', m: 'min' },
    subscribers: 'Subscribers',
    table: 'Table',
    chart: 'Chart',
    period: 'Period | Periods',
    withdraw: 'Remove',
    scheduledAt: 'Scheduled At',
    attendedAt: 'Attended At',
    actions: {
      edited: 'Edited',
      created: 'Created',
      deleted: 'Deleted',
      canceled: 'Canceled',
      removed: 'Removed',
    },
    updatedAgo: 'Updated {minutes} minutes ago',
    deleting: {
      type: 'Please type in the {word} of the {entity} to confirm. | Please type the number {entity} for confirm the deletion.',
      undone: 'This action cannot be undone.',
      permanently: 'This will permanently delete the {entity} | This will permanently delete the {entity} selected',
      all: 'and all data associated.',
      sure: 'Are you sure you want remove this {entity}?',
      caution: 'Unexpected bad things will happen if you don’t read this!',
    },
    creating: 'Creating a {entity} | Creating {entity}',
    editing: 'Editing a {entity} | Editing {entity}',
    deleted: {
      success: {
        title: '{entity} deleted | {entity} deleted',
        description: 'The {entity} {name} was deleted. | The {name} {entity} was deleted.',
      },
      fail: {
        title: 'Error deleting {entity} | Error deleting {entity}',
        description: 'The {entity} {name} cannot be deleted, please try again. | The {name} {entity} cannot be deleted, please try again.',
      },
    },
    langs: {
      es: 'Spanish',
      en: 'English',
    },
    copied: {
      error: 'The code cannot be copied, please try manually',
      successful: 'The code was copied successful',
    },
    statuses: {
      online: 'Connected',
      occupied: 'In call',
      offline: 'Disconnected',
      busy: 'Occupied',
      available: 'Available',
    },
    'recording-status': {
      pending: 'Pending',
      rejected: 'Rejected',
      approved: 'Approved',
      deleted: 'Deleted',
      recording: 'Recording',
      processing: 'Processing',
      failed: 'Process fail',
    },
    storages: {
      s3: 'AWS S3',
      azure: 'Azure Blob',
      gcp: 'GCP Storage',
      ftp: 'FTP',
      videsk: 'Videsk Storage',
    },
    privileges: {
      admin: 'Administrator',
      supervisor: 'Supervisor',
      agent: 'Agent',
      'agent-recording': 'Agent (+Auditor)',
      'recording-reviewer': 'Recording auditor',
    },
    networkError: 'Network error',
    verifyFields: 'Check form fields',
    unexpectedError: 'Unexpected error',
    changePassword: 'Change password',
    newPassword: 'New password',
    passwordNotMatch: 'Passwords not match',
    passwordConfirm: 'Confirm password',
    helpCenter: 'Help center',
    changelog: 'Changelog',
    scheduledBy: 'Scheduled By',
  },
  es: {
    id: 'ID',
    loading: 'Cargando',
    save: 'Guardar cambios',
    delete: 'Eliminar',
    publish: 'Publicar',
    public: 'Público',
    yes: 'Si',
    no: 'No',
    view: 'Ver',
    'view-live': 'Ver en vivo',
    ok: 'Aceptar',
    cancel: 'Cancelar',
    edit: 'Editar {entity}',
    remove: 'Eliminar {entity}',
    confirm: 'Confirmar',
    reports: 'Ver reportes',
    suspend: 'Suspender',
    reload: 'Actualizar',
    reset: 'Limpiar',
    filter: 'Filtrar | Filtros',
    name: 'Nombre',
    empty: 'No se han encontrado datos. { extra }',
    create: 'Crear {entity}',
    firstname: 'Nombre',
    lastname: 'Apellido',
    email: 'Correo electrónico',
    message: 'Mensaje',
    privilege: 'Privilegio',
    password: 'Contraseña',
    default: 'Predeterminado',
    custom: 'Personalizado',
    start: 'Inicio',
    end: 'Fin',
    today: 'Hoy',
    second: 'segundo | segundos',
    minute: 'minuto | minutos',
    hour: 'hora | horas',
    secondShort: 's',
    minuteShort: 'min',
    hourShort: 'h',
    date: 'Fecha',
    month: 'Mes | Meses',
    week: 'Semana | Semanas',
    dayOfWeek: 'Día de la semana | Días de la semana',
    day: 'Día | Días',
    year: 'Año | Años',
    install: 'Instalar',
    owner: 'Propietario',
    copy: 'Copiar',
    ip: 'Dirección IP',
    users: 'Usuarios',
    secret: 'Secreto',
    log: 'Registro',
    description: 'Descripción',
    label: 'Nombre',
    duration: 'Duración',
    daysAndHours: 'Días de la semana',
    blockedDate: 'Fecha bloqueada | Fechas bloqueadas',
    callDetails: 'Detalles de la llamada',
    visible: 'Visible',
    hidden: 'Oculto',
    url: 'URL',
    event: 'Evento',
    visibility: 'Visibilidad',
    type: 'Tipo',
    value: 'Value',
    internalId: 'ID Interno',
    integrationId: 'ID de integración',
    fields: 'Campos',
    activate: 'Activar',
    active: 'Activo',
    inactive: 'Inactivo',
    settings: 'Ajustes',
    enable: 'Habilitar',
    disable: 'Deshabilitar',
    add: 'Añadir',
    activated: 'Activado',
    deactivated: 'Desactivado',
    new: 'Nuevo',
    website: 'Sitio web',
    optional: 'Opcional',
    options: 'Opciones',
    attributes: 'Atributos',
    feedback: 'Feedback',
    return: 'Volver',
    field: 'Campo | Campos',
    color: 'Color',
    required: 'Requerido',
    readonly: 'Solo lectura',
    disabled: 'Deshabilitado',
    logo: 'Logo',
    reminder: 'Recordatorio | Recordatorios',
    title: 'Título',
    days: 'Días',
    template: 'Plantilla',
    subject: 'Asunto',
    status: 'Estado',
    startAt: 'Inicio el',
    endAt: 'Termina el',
    reassign: 'Reasignar',
    storage: 'Almacenamiento',
    step: 'Paso',
    local: 'Local',
    cloud: 'Cloud',
    video: 'Video',
    show: 'Mostrar',
    hide: 'Ocultar',
    method: 'Método',
    example: 'Ejemplo',
    docs: 'Documentación',
    source: 'Fuente',
    error: 'Error',
    all: 'Todo | Todos',
    notFound: 'Elimando / No encontrado',
    createdAt: 'Creado el',
    udpatedAt: 'Actulizado el',
    createdBy: 'Creado por',
    updatedBy: 'Actualizado por',
    answered: 'Contestada | Contestadas',
    search: 'Buscar',
    abandoned: 'Abandonada | Abandonadas',
    transferred: 'Transferida | Transferidas',
    dismissed: 'Rechazada | Rechazadas',
    notification: 'Notificación',
    average: 'Promedio | Promedios',
    answer: 'Respuesta | Respuestas',
    response: 'Respuesta | Respuestas',
    location: 'Ubicación | Ubicaciones',
    total: 'Total',
    os: 'Sistema operativo | Sistemas operativos',
    browser: 'Navegador | Navegadores',
    city: 'Ciudad | Ciudades',
    region: 'Region | Regiones',
    device: 'Dispositivo | Dispositivos',
    country: 'País | Países',
    export: 'Exportar | Exportaciones',
    unknown: 'Desconocido',
    ascending: 'Ascendente',
    descending: 'Desencendete',
    order: 'Orden',
    download: 'Descargar',
    preview: 'Previsualizar',
    close: 'Cerrar',
    appointmentDetails: 'Detalles de la reunión',
    agent: 'Agente',
    user: 'Cliente',
    unroll: 'Desenrolar',
    enroll: 'Enrolar',
    next: 'Siguiente',
    referrer: 'Enlace | Enlaces',
    enabled: 'Habilitado',
    hours: 'Horas',
    durationUnits: { w: 'sem', d: 'd', h: 'h', m: 'min' },
    subscribers: 'Suscriptores',
    table: 'Tabla',
    chart: 'Gráfico',
    period: 'Periodo | Periodos',
    withdraw: 'Quitar',
    scheduledAt: 'Agendado el',
    attendedAt: 'Atendido el',
    actions: {
      edited: 'Editado',
      created: 'Creado',
      deleted: 'Eliminado',
      canceled: 'Cancelado',
      removed: 'Removido',
    },
    updatedAgo: 'Actualizado hace {minutes} minutos',
    deleting: {
      type: 'Escriba el {word} del {entity} para confirmar. | Escriba el número {entity} para confirmar la eliminación.',
      undone: 'Esta acción no se puede deshacer.',
      permanently: 'Esto eliminará permanentemente el {entity} | Esto eliminará permanentemente los {entity} seleccionados',
      all: 'y todos los datos asociados.',
      sure: 'Está seguro que desea eliminar este {entity}? | Está seguro que desea eliminar estos {entity}?',
      caution: '¡Cosas malas e inesperadas sucederán si no lee esto!',
    },
    creating: 'Creando un {entity} | Creando {entity}',
    editing: 'Editando un {entity} | Editando {entity}',
    deleted: {
      success: {
        title: 'El {entity} fue eliminado | Los {entity} fueron eliminados',
        description: 'El {entity} {name} fue eliminado. | Los {name} {entity} fueron eliminados.',
      },
      fail: {
        title: 'Error eliminando el {entity} | Error eliminando los {entity}',
        description: 'No se ha podido eliminar el {entity} {name}, intente nuevamente. | No se ha podido eliminar {name} {entity}, intente nuevamente.',
      },
    },
    langs: {
      es: 'Español',
      en: 'Inglés',
    },
    copied: {
      error: 'El código no se puede copiar, intente manualmente',
      successful: 'El código fue copiado exitosamente',
    },
    statuses: {
      online: 'Conectado',
      occupied: 'En llamada',
      offline: 'Desconectado',
      busy: 'Ocupado',
      available: 'Disponible',
    },
    'recording-status': {
      pending: 'Pendiente',
      rejected: 'Rechazado',
      approved: 'Aprobado',
      deleted: 'Eliminado',
      recording: 'Grabando',
      processing: 'Procesando',
      failed: 'Procesamiento fallido',
    },
    storages: {
      s3: 'AWS S3',
      azure: 'Azure Blob',
      gcp: 'GCP Storage',
      ftp: 'FTP',
      videsk: 'Videsk Storage',
    },
    privileges: {
      admin: 'Administrador',
      supervisor: 'Supervisor',
      agent: 'Agente',
      'agent-recording': 'Agente (+Auditor)',
      'recording-reviewer': 'Auditor grabaciones',
    },
    networkError: 'Error de red',
    verifyFields: 'Verifique los campos',
    unexpectedError: 'Error inesperado',
    changePassword: 'Cambiar contraseña',
    newPassword: 'Nueva contraseña',
    passwordNotMatch: 'Las contraseñas no coinciden',
    passwordConfirm: 'Confirme contraseña',
    helpCenter: 'Centro de ayuda',
    changelog: 'Novedades',
    scheduledBy: 'Agendado por',
  },
  fr: {
    id: 'ID',
    loading: 'Chargement',
    save: 'Enregistrer les modifications',
    delete: 'Supprimer',
    publish: 'Publier',
    public: 'Public',
    yes: 'Oui',
    no: 'Non',
    view: 'Voir',
    'view-live': 'Voir en direct',
    ok: 'Ok',
    cancel: 'Annuler',
    edit: 'Modifier {entity}',
    remove: 'Supprimer {entity}',
    confirm: 'Confirmer',
    reports: 'Voir les rapports',
    suspend: 'Suspendre',
    reload: 'Mettre à jour',
    reset: 'Réinitialiser',
    filter: 'Filtrer | Filtres',
    name: 'Nom',
    empty: 'Aucune donnée trouvée. {extra}',
    create: 'Créer {entity}',
    firstname: 'Prénom',
    lastname: 'Nom',
    email: 'Email',
    message: 'Message',
    privilege: 'Privilège',
    password: 'Mot de passe',
    default: 'Par défaut',
    custom: 'Personnalisé',
    start: 'Début',
    end: 'Fin',
    today: 'Aujourd\'hui',
    second: 'Seconde | Secondes',
    minute: 'Minute | Minutes',
    hour: 'Heure | Heures',
    secondShort: 's',
    minuteShort: 'min',
    hourShort: 'h',
    month: 'Mois | Mois',
    week: 'Semaine | Semaines',
    dayOfWeek: 'Jour de la semaine | Jours de la semaine',
    day: 'Jour | Jours',
    year: 'Année | Années',
    date: 'Date',
    install: 'Installer',
    owner: 'Propriétaire',
    copy: 'Copier',
    ip: 'Adresse IP',
    users: 'Utilisateurs',
    secret: 'Secret',
    log: 'Journal',
    description: 'Description',
    label: 'Étiquette',
    duration: 'Durée',
    daysAndHours: 'Jours de la semaine',
    blockedDate: 'Date bloquée | Dates bloquées',
    callDetails: 'Détails des appels',
    visible: 'Visible',
    hidden: 'Caché',
    url: 'URL',
    event: 'Événement',
    visibility: 'Visibilité',
    type: 'Type',
    internalId: 'ID interne',
    integrationId: 'ID d\'intégration',
    fields: 'Champs',
    activate: 'Activer',
    active: 'Actif',
    inactive: 'Inactif',
    settings: 'Paramètres',
    enable: 'Activer',
    disable: 'Désactiver',
    add: 'Ajouter',
    activated: 'Activé',
    deactivated: 'Désactivé',
    new: 'Nouveau',
    website: 'Site web',
    optional: 'Optionnel',
    options: 'Options',
    attributes: 'Attributs',
    feedback: 'Retour',
    return: 'Retourner',
    field: 'Champ | Champs',
    color: 'Couleur',
    required: 'Requis',
    readonly: 'Lecture seule',
    disabled: 'Désactivé',
    logo: 'Logo',
    reminder: 'Rappel | Rappels',
    title: 'Titre',
    days: 'Jours',
    template: 'Modèle',
    subject: 'Objet',
    status: 'Statut',
    startAt: 'Commence à',
    endAt: 'Se termine à',
    reassign: 'Réaffecter',
    storage: 'Stockage',
    step: 'Étape',
    local: 'Local',
    cloud: 'Cloud',
    video: 'Vidéo',
    show: 'Afficher',
    hide: 'Cacher',
    method: 'Méthode',
    example: 'Exemple',
    docs: 'Documentation',
    source: 'Source',
    error: 'Erreur',
    all: 'Tout',
    notFound: 'Supprimé / Non trouvé',
    createdAt: 'Créé le',
    udpatedAt: 'Mis à jour le',
    createdBy: 'Créé par',
    updatedBy: 'Mis à jour par',
    answered: 'Répondu | Répondus',
    search: 'Rechercher',
    abandoned: 'Abandonné | Abandonnés',
    transferred: 'Transféré | Transférés',
    dismissed: 'Rejeté | Rejetés',
    notification: 'Notification',
    average: 'Moyenne | Moyennes',
    answer: 'Réponse | Réponses',
    response: 'Réponse | Réponses',
    location: 'Lieu | Lieux',
    total: 'Total',
    os: 'OS | OS',
    browser: 'Navigateur | Navigateurs',
    city: 'Ville | Villes',
    region: 'État | États',
    device: 'Appareil | Appareils',
    country: 'Pays | Pays',
    export: 'Exporter | Exportations',
    unknown: 'Inconnu',
    ascending: 'Ascendant',
    descending: 'Descendant',
    order: 'Ordre',
    close: 'Fermer',
    appointmentDetails: 'Détails du rendez-vous',
    agent: 'Agent',
    user: 'Client',
    download: 'Télécharger',
    preview: 'Aperçu',
    unroll: 'Dérouler',
    enroll: 'S\'inscrire',
    next: 'Suivant',
    referrer: 'Lien | Liens',
    enabled: 'Activé',
    hours: 'Heures',
    durationUnits: { w: 'sem', d: 'j', h: 'h', m: 'min' },
    subscribers: 'Abonné·e·s',
    table: 'Tableau',
    chart: 'Graphique',
    period: 'Période | Périodes',
    withdraw: 'Retirer',
    scheduledAt: 'Prévu le',
    attendedAt: 'J\'ai assisté à',
    actions: {
      edited: 'Modifié',
      created: 'Créé',
      deleted: 'Supprimé',
      canceled: 'Annulé',
      removed: 'Retiré',
    },
    updatedAgo: 'Mis à jour il y a {minutes} minutes',
    deleting: {
      type: 'Veuillez taper le {word} du {entity} pour confirmer. | Veuillez taper le numéro {entity} pour confirmer la suppression.',
      undone: 'Cette action ne peut pas être annulée.',
      permanently: 'Cela supprimera définitivement le {entity} | Cela supprimera définitivement le {entity} sélectionné',
      all: 'et toutes les données associées.',
      sure: 'Êtes-vous sûr de vouloir supprimer ce {entity} ?',
      caution: 'Des choses inattendues peuvent se produire si vous ne lisez pas ceci !',
    },
    creating: 'Création d\'un {entity} | Création {entity}',
    editing: 'Modification d\'un {entity} | Modification {entity}',
    deleted: {
      success: {
        title: '{entity} supprimé | {entity} supprimé',
        description: 'Le {entity} {name} a été supprimé. | Le {name} {entity} a été supprimé.',
      },
      fail: {
        title: 'Erreur lors de la suppression du {entity} | Erreur lors de la suppression du {entity}',
        description: 'Le {entity} {name} ne peut pas être supprimé, veuillez réessayer. | Le {name} {entity} ne peut pas être supprimé, veuillez réessayer.',
      },
    },
    langs: {
      es: 'Espagnol',
      en: 'Anglais',
    },
    copied: {
      error: 'Le code ne peut pas être copié, veuillez essayer manuellement',
      successful: 'Le code a été copié avec succès',
    },
    statuses: {
      online: 'Connecté',
      occupied: 'En appel',
      offline: 'Déconnecté',
      busy: 'Occupé',
      available: 'Disponible',
    },
    'recording-status': {
      pending: 'En attente',
      rejected: 'Rejeté',
      approved: 'Approuvé',
      deleted: 'Supprimé',
      recording: 'Enregistrement',
      processing: 'Traitement',
      failed: 'Échec du traitement',
    },
    storages: {
      s3: 'AWS S3',
      azure: 'Azure Blob',
      gcp: 'Stockage GCP',
      ftp: 'FTP',
      videsk: 'Stockage Videsk',
    },
    privileges: {
      admin: 'Administrateur',
      supervisor: 'Superviseur',
      agent: 'Agent',
      'agent-recording': 'Agent (+Auditeur)',
      'recording-reviewer': 'Auditeur d\'enregistrements',
    },
    networkError: 'Erreur réseau',
    verifyFields: 'Vérifiez les champs du formulaire',
    unexpectedError: 'Erreur inattendue',
    changePassword: 'Changer le mot de passe',
    newPassword: 'Nouveau mot de passe',
    passwordNotMatch: 'Les mots de passe ne correspondent pas',
    passwordConfirm: 'Confirmer le mot de passe',
    helpCenter: 'Centre d\'aide',
    changelog: 'Journal des modifications',
    scheduledBy: 'Programmé par',
}

};
